import React, { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import { Container, StoreInfoWrapper } from "../Styles/Wrappers";
import OtherSuggestions from "../../components/OtherSuggestions/OtherSuggestions";
import { CardGridWrapper } from "../../components/Card/CardGridWrapper";
import "./Store.css";
import Card from "../../components/Card/Card";
import Sustainability from "../../components/Sustainability/Sustainability";
import { dbFind, dbFindStoreWithSlug } from "../../library/database";
import TitleBanner from "../../components/TitleBanner/TitleBanner";
import LoginModal from "../User/LoginModal";
import Associate from "../../components/Associate/Associate";
import { servicesFilter } from "../Home/servicesFilter";
import { productFilter } from "./productFilter";
import { AppContext } from "../../context";
import { ENTITIES } from "../../entities/entitiesConfig";
import Facilities from "../../components/Facilities/Facilities";

const Store = ({ match, history }) => {
  const [store, setStore] = useState(null);
  // storeProducts - all products from the store
  const [storeProducts, setStoreProducts] = useState([]);
  // products - all listed products
  const [products, setProducts] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const location = useLocation();

  const info = useContext(AppContext);

  useEffect(() => {
    console.log("Store.set language");
    // const language = history?.location?.pathname?.substring(1);
    const language = match.path?.substring(1, 3);
    if (
      language === "en" ||
      language === "fr" ||
      language === "es" ||
      language === "de" ||
      language === "it"
    )
      info.setLanguage(language);
    else info.setLanguage("pt");
  }, []);

  useEffect(() => {
    console.log("Store.get store");
    const getData = async () => {
      const store = await dbFindStoreWithSlug(match.params.slug);

      if (store) {
        console.log(`store`, store);
        setStore(store);
      }
    };
    getData();
  }, []);

  // TODO transferir para entitiesConfig.js
  const title = (entity) => {
    switch (entity) {
      case "lodge":
        return info.t("reserve_rooms");
      case "restaurant":
        return info.t("reserve_meals");
      case "experience":
        return info.t("reserve_experiences");
      case "goods":
        return info.t("reserve_products");
      case "event":
        return info.t("reserve_tickets");
      case "guide":
        return info.t("schedule_guides");
      case "monument":
        return info.t("reserve_monuments");
      default:
        return info.t("store_not_available");
    }
  };

  const subtitle = (user) => {
    if (!info?.user) return info.t("registerOrLoginForReservations");
    else return "Utilizador: " + (info?.user?.name || info?.user?.email);
    if (info?.user?.roles?.includes("coworker"))
      return "Está a pesquisar como co-worker (inclui descontos e produtos específicos)";
  };

  return (
    <>
      {store && store.type && (
        <Container>
          {store.facilities && <Facilities store={store} />}
          {store.is_associate && <Associate storeName={store.name} />}

          {store.ods && (
            <Sustainability
              sustainability={store.ods}
              lang="PT"
              iconWidth={80}
            />
          )}

          <>
            <TitleBanner
              color="grey"
              title={title(store.type)}
              subtitle={subtitle(info.user)}
            >
              {!info.user && (
                <button
                  className="ahp-button ahp-xl"
                  type="button"
                  style={{ margin: "1.7rem 1.5rem 1.7rem 1.5rem" }}
                  onClick={() => setIsModalVisible(true)}
                  data-test-id="login-btn"
                >
                  {info.t("loginRegister")}
                </button>
              )}
            </TitleBanner>

            {store &&
              ENTITIES[store.type].StoreFilter &&
              React.createElement(ENTITIES[store.type].StoreFilter, {
                store: store,
                products: storeProducts,
                setProducts: setProducts,
                match: match,
              })}

            <CardGridWrapper>
              {products?.length > 0 &&
                products?.map(
                  (product, index) =>
                    product.status !== "hidden" && (
                      <Card
                        entity={store.type}
                        storeProp={store}
                        product={product}
                        key={index}
                        reserveBtn={true}
                      />
                    )
                )}
              {(!products || products?.length === 0) && (
                <div>{info.t("noResults").toUpperCase()}</div>
              )}
            </CardGridWrapper>
          </>
          {/* <button
            type="button"
            className="ahp-button ahp-xl"
            onClick={() => window.location.replace("/reservas")}
          >
            Carrinho de reservas
          </button> */}
        </Container>
      )}
      <LoginModal
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
      {/* <OtherSuggestions /> */}
    </>
  );
};

export default Store;
